import React from '../../vendor/react';
import { brandConfig } from '../../config/brand';

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark">
      <img src={brandConfig.logoPath} alt="" className="brand-mark__icon" />
      {!compact && (
        <div>
          <strong>{brandConfig.shortName}</strong>
          <span>Comercio conectado</span>
        </div>
      )}
    </div>
  );
}
